import corner1 from '@/assets/img/icons/spot-illustrations/corner-1.png';
import corner3 from '@/assets/img/icons/spot-illustrations/corner-3.png';
import corner2 from '@/assets/img/icons/spot-illustrations/corner-2.png';

import Background from '@/components/common/Background';
import { Card, Col, Row } from 'react-bootstrap';
import TextLoading from '@/app/common/components/skeleton/TextLoading';
import IconWithLabel from './internal-seo/IconWithLabel';
import {
  breakpointsMediaQuery,
  getColor,
  useMediaQuery
} from '@/helpers/utils';

const OverviewCardsSkeleton = () => {
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);

  return (
    <>
      <Card className="h-100 my-3 overflow-hidden">
        <Background image={corner3} className="rounded-soft bg-card" />
        <Card.Body className="z-1">
          <Row className="g-3 h-100 align-items-end">
            <IconWithLabel
              title="تگ عنوان"
              md={12}
              sm={12}
              xs={12}
              color={getColor('navbar-vertical-default-link-active-color')}
              icon="heading"
              text={<TextLoading />}
            />
            <IconWithLabel
              title="توضیح متا"
              md={12}
              sm={12}
              xs={12}
              color={getColor('navbar-vertical-default-link-active-color')}
              icon="file-lines"
              text={<TextLoading />}
            />
          </Row>
        </Card.Body>
      </Card>
      <Row className="g-3 my-3">
        <Col xl={8} lg={12}>
          <Card className="h-100 overflow-hidden">
            <Background image={corner1} className="rounded-soft bg-card" />
            <Card.Body className="z-1">
              <Row className="g-3 h-100 align-items-end">
                <IconWithLabel
                  title="نشانی"
                  md={12}
                  sm={12}
                  xs={12}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="link"
                  text={<TextLoading />}
                />
                <IconWithLabel
                  title="کنونیکال"
                  md={12}
                  sm={12}
                  xs={12}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="circle-dot"
                  text={<TextLoading />}
                />
                <IconWithLabel
                  title="تگ robots"
                  md={12}
                  sm={12}
                  xs={12}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="tag"
                  text={<TextLoading />}
                />

                <IconWithLabel
                  title="Robots.txt"
                  md={12}
                  sm={12}
                  xs={12}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="robot"
                  text={<TextLoading />}
                />
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col xl={4} lg={12}>
          <Card className="h-100 overflow-hidden">
            <Background image={corner2} className="rounded-soft bg-card" />
            <Card.Body className="z-1">
              <Row className="g-3 h-100 align-items-end">
                <IconWithLabel
                  title="تگ کیورد"
                  md={6}
                  sm={6}
                  xs={6}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="bolt"
                  text={<TextLoading />}
                />
                <IconWithLabel
                  title="زبان"
                  md={6}
                  sm={6}
                  xs={6}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="language"
                  text={<TextLoading />}
                />
                <IconWithLabel
                  title="تعداد کلمات"
                  md={6}
                  sm={6}
                  xs={6}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="rectangle-list"
                  text={<TextLoading />}
                />
                <IconWithLabel
                  title="تعداد جملات"
                  md={6}
                  sm={6}
                  xs={6}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="rectangle-list"
                  text={<TextLoading />}
                />
                <IconWithLabel
                  title={isMdUp ? 'زمان تقریبی مطالعه' : 'مطالعه'}
                  md={6}
                  sm={6}
                  xs={6}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="clock"
                  text={<TextLoading />}
                />
                <IconWithLabel
                  title="ناشر"
                  md={6}
                  sm={6}
                  xs={6}
                  color={getColor('navbar-vertical-default-link-active-color')}
                  icon="upload"
                  text={<TextLoading />}
                />
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default OverviewCardsSkeleton;
